import { FC } from 'react';
import { CouponsView } from '../components';

export const CouponsPage: FC = () => {
  return <CouponsView />;
};
